import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, ClickAwayListener, Paper, Popper, Stack, Toolbar } from '@mui/material';

// project import
import Search from './Search';
import Profile from './Profile';
import Localization from './Localization';
import IconButton from 'layout/mantis/components/@extended/IconButton';
import Transitions from 'layout/mantis/components/@extended/Transitions';

// assets
import { MoreOutlined } from '@ant-design/icons';
import { Typography } from '@mui/material';
import useAuthContext from 'context/useAuthContext';

// ==============================|| HEADER CONTENT - MOBILE ||============================== //

const MobileSection = () => {
	const theme = useTheme();

	const { auth } = useAuthContext();
	const user = auth?.currentUser ?? null;

	const [open, setOpen] = useState(false);
	const anchorRef = useRef<any>(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: MouseEvent | TouchEvent) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	const prevOpen = useRef(open);
	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	const iconBackColorOpen = theme.palette.mode === 'dark' ? 'grey.200' : 'grey.300';
	const iconBackColor = theme.palette.mode === 'dark' ? 'background.default' : 'grey.100';

	return (
		<>
			<Box sx={ { flexShrink: 0, ml: 0.75 } }>
				<Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.5 }}>
					<Stack direction="column" textAlign={'right'}>
						<Typography variant="subtitle1">{user?.name}</Typography>
						<Typography variant="body2">{(user?.email ? user?.email : '') + (user?.nid ? ' - ' + user?.nid : '')}</Typography>
					</Stack>
					<IconButton
						sx={ { color: 'text.primary', bgcolor: open ? iconBackColorOpen : iconBackColor } }
						aria-label='open more menu'
						ref={ anchorRef }
						aria-controls={ open ? 'menu-list-grow' : undefined }
						aria-haspopup='true'
						onClick={ handleToggle }
						color='secondary'
						variant='light'
					>
						<MoreOutlined />
					</IconButton>
				</Stack>
				
			</Box>
			<Popper
				placement='bottom-end'
				open={ open }
				anchorEl={ anchorRef.current }
				role={ undefined }
				transition
				disablePortal
				sx={ { width: '100%' } }
				popperOptions={ {
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [0, 9]
							}
						}
					]
				} }
			>
				{ ({ TransitionProps }) => (
					<Transitions type='fade' in={ open } { ...TransitionProps }>
						<Paper sx={ { boxShadow: theme.customShadows.z1 } }>
							<ClickAwayListener onClickAway={ handleClose }>
								<AppBar color='inherit'>
									<Toolbar>
										<Search />
										{/* <Localization /> */}
										<Profile />
									</Toolbar>
								</AppBar>
							</ClickAwayListener>
						</Paper>
					</Transitions>
				) }
			</Popper>
		</>
	);
};

export default MobileSection;
